/**V Factory classes V */
let registeredFactories = {};
//Create a select
registeredFactories["select"] = class SelectFactory {
    constructor(data, attributes) {
        this.select = document.createElement("select");
        setAttributes(this.select, attributes);
        for (var i = 0; i < data.length; i++) {
            var option = document.createElement("option");
            if (!data[i].value && !data[i].name) {
                option.value = data[i];
                option.text = data[i];
            }
            else {
                option.value = data[i].value;
                option.text = data[i].name;
            }
            this.select.appendChild(option);
        }
    }
};
//Create a list of options
registeredFactories["options"] = class optionsFactory {
    constructor(data, attributes) {
        //this.select = document.createElement("select");
        //setAttributes(this.select, attributes);
        this.options = [];
        for (var i = 0; i < data.length; i++) {
            var option = document.createElement("option");
            if (!data[i].value && !data[i].name) {
                option.value = data[i];
                option.text = data[i];
            }
            else {
                option.value = data[i].value;
                option.text = data[i].name;
            }
            this.options.push(option);
        }
    }
};
//Create the submit button
registeredFactories["submit"] = class SubmitFactory {
    constructor(text, attributes) {
        this.submit = document.createElement("input");
        this.submit.type = "submit";
        this.submit.value = text ? text : "";
        setAttributes(this.submit, attributes);
    }
}

//Create reset button
registeredFactories["reset"] = class SubmitFactory {
    constructor(text, attributes) {
        this.reset = document.createElement("input");
        this.reset.type = "reset";
        this.reset.value = text ? text : "";
        setAttributes(this.submit, attributes);
    }
}
/**Main Factory, Will be exported*/

class FilterFactory {
    constructor(type, data, attributes) {
        return new registeredFactories[type](data, attributes)[type];
    }
}
export default FilterFactory;

/** Small Helper functions */
function setAttributes(element, attributes) {
    for (let i in attributes) {
        if (i === "className") {
            element.className = attributes[i];
        }
        else {
            element.setAttribute(i, attributes[i]);
        }
    }
}
